export default "__VITE_ASSET__BLsyfklO__"